import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=9fc75212&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"
import style0 from "./personal.vue?vue&type=style&index=0&id=9fc75212&prod&scoped=true&lang=scss"
import style1 from "./personal.vue?vue&type=style&index=1&id=9fc75212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc75212",
  null
  
)

export default component.exports